import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppFloat.css";

const WhatsAppFloat = () => {

  const phone = "919876543210"; // Replace with your number

  const message =
    "Hello Swarup Hospital, I would like to know more about your services.";

  return (
    <a
      href={`https://wa.me/${phone}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
    >
      <div className="whatsapp-tooltip">
        💬 Chat with us
      </div>

      <FaWhatsapp className="whatsapp-icon" />
    </a>
  );
};

export default WhatsAppFloat;